<mat-action-list class="smp-action-list"
                 cdkDropList
                 [cdkDropListDisabled]="!reorderable"
                 (cdkDropListDropped)="setNewOrder($event)"
>

    <ng-container *ngFor="let item of items; let idx = index">

        <button mat-list-item
                cdkDrag
                class="full-width mat-list-item-content-at-full-width smp-action-list-button"
                [cdkDragLockAxis]="lockAxis"
                [ngClass]="{ 'active': selected && item[identifier ? identifier : 'id'] === selected[identifier ? identifier : 'id'] }">

            <div id="{{idPrefix}}entry_{{idx}}.btn.select"
                 class="smp-action-list-wrapper-div" (click)="selectItem(item)">

                <i *ngIf="reorderable" class="dr-n-drop-handle dr-fa-icon fa fa-ellipsis-v" cdkDragHandle></i>

                <!-- If we haven't passed on a custom template, we simply show the actionListDisplayName -->
                <span class="action-list-display-name" *ngIf="!template">{{ item.actionListDisplayName | translate }}</span>

                <!-- Custom template below if one was passed on -->
                <ng-container *ngIf="template"
                              [ngTemplateOutlet]="template"
                              [ngTemplateOutletContext]="{ data: item }">
                </ng-container>

            </div>

            <button id="{{idPrefix}}entry_{{idx}}.btn.open_menu"
                    class="menu_button"
                    mat-icon-button
                    *ngIf="hasMenu"
                    [matMenuTriggerFor]="actionMenu">
                <mat-icon class="dr-material-icon">more_horiz</mat-icon>
            </button>

            <mat-menu #actionMenu="matMenu" class="smp-action-list-menu">

                <mat-action-list class="smp-action-list-menu-action-list">

                    <ng-container *ngFor="let option of options" >
                        <mat-list-item id="{{idPrefix}}entry_{{idx}}.menu.btn.{{option.option}}"
                                       *ngIf="!option.show || option.show(item)"
                                       class="smp-action-list-menu-action-list-item"
                                       (click)="option.action(item)">
                            <span mat-line>{{ option.label | translate }}</span>
                        </mat-list-item>
                    </ng-container>

                </mat-action-list>

            </mat-menu>

        </button>

        <ng-container *ngIf="addOn"
                      [ngTemplateOutlet]="addOn"
                      [ngTemplateOutletContext]="{ data: item }">
        </ng-container>

    </ng-container>

</mat-action-list>
